"use strict";

const GlobalSearchPort = {
  add: (app) => {
    window.addEventListener("outsideGlobalSearchTriggered", function () {
      app.ports.globalSearchTriggeredPort.send(null);
    });

    if (app.ports.enableGlobalSearchShortcutPort) {
      app.ports.enableGlobalSearchShortcutPort.subscribe(() => {
        document.addEventListener("keydown", function keydownHandler(e) {
          if ((e.metaKey || e.ctrlKey) && e.key === "k") {
            app.ports.globalSearchTriggeredPort.send(null);
            e.preventDefault();
          }
        });
      });
    }

    // Wire the clinical search port to call React function
    if (app.ports.openClinicalSearchPort) {
      app.ports.openClinicalSearchPort.subscribe(() => {
        if (window.openClinicalSearchBar) {
          window.openClinicalSearchBar();
        }
      });
    }
  },
};

module.exports = GlobalSearchPort;
